import { GET_PRODUCTS_FAMILIES } from "../../actions/imagedatabase/productsFamilies";

export default function productsFamilies(state = [], action) {
  switch (action.type) {
    case GET_PRODUCTS_FAMILIES:
      return action.productsFamilies;
    default:
      return state;
  }
}
